var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceIcon3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 8h10v10H7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M11 2h6v5c-1.501-1.188-3.233-1.815-5-1.812-1.767-.004-3.499.624-5 1.81V2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#545563",
  fillRule: "evenodd",
  d: "M12 22a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-12.375c-.32 0-.533.383-.96 1.15l-.111.199c-.122.218-.182.326-.277.398s-.213.1-.45.152l-.213.05c-.83.187-1.246.28-1.345.598s.185.65.75 1.31l.147.172c.16.188.242.28.278.398s.023.242 0 .493l-.023.228c-.085.883-.128 1.325.13 1.521s.647.017 1.425-.34l.2-.093c.222-.101.332-.153.449-.153s.227.052.449.153l.2.092c.778.359 1.167.537 1.426.341s.214-.638.129-1.521l-.023-.228c-.023-.251-.036-.376 0-.493s.117-.21.278-.398l.146-.171c.566-.662.85-.993.75-1.311-.098-.317-.513-.41-1.344-.599l-.213-.049c-.236-.053-.355-.079-.45-.152-.095-.072-.155-.18-.277-.398l-.11-.198c-.428-.768-.642-1.151-.961-1.151",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#service-icon-3_svg__a)",
  fillRule: "evenodd",
  d: "M12 22a9 9 0 1 0 0-18 9 9 0 0 0 0 18m0-12.375c-.32 0-.533.383-.96 1.15l-.111.199c-.122.218-.182.326-.277.398s-.213.1-.45.152l-.213.05c-.83.187-1.246.28-1.345.598s.185.65.75 1.31l.147.172c.16.188.242.28.278.398s.023.242 0 .493l-.023.228c-.085.883-.128 1.325.13 1.521s.647.017 1.425-.34l.2-.093c.222-.101.332-.153.449-.153s.227.052.449.153l.2.092c.778.359 1.167.537 1.426.341s.214-.638.129-1.521l-.023-.228c-.023-.251-.036-.376 0-.493s.117-.21.278-.398l.146-.171c.566-.662.85-.993.75-1.311-.098-.317-.513-.41-1.344-.599l-.213-.049c-.236-.053-.355-.079-.45-.152-.095-.072-.155-.18-.277-.398l-.11-.198c-.428-.768-.642-1.151-.961-1.151",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-icon-3_svg__a",
  x1: 12,
  x2: 12,
  y1: 4,
  y2: 27.063,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#F4F8FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.672,
  stopColor: "#568DFE"
})))));
export default SvgServiceIcon3;